const mistakes = [
  {
    icon: "ri-file-damage-line",
    title: "Wrong Photo Size or Quality",
    description: "Passport photos must be 2x2 inches with a white background and taken within the last 6 months. Fairbanks post offices and pharmacies typically offer photo services.",
  },
  {
    icon: "ri-snowflake-line",
    title: "Not Accounting for Alaska's Shipping Delays",
    description: "Overnight shipping from Fairbanks to the lower 48 takes longer in winter due to weather delays. Always add extra buffer time when planning your passport timeline.",
  },
  {
    icon: "ri-user-unfollow-line",
    title: "Forgetting Both Parents for Child Applications",
    description: "Child passports under 16 require both parents or legal guardians present at the acceptance facility — or a notarized consent form if one parent can't attend.",
  },
  {
    icon: "ri-time-line",
    title: "Applying Too Late Before Travel",
    description: "Fairbanks residents should apply at least 3 weeks before travel. Remote Alaska geography adds shipping days that continental U.S. applicants don't face.",
  },
  {
    icon: "ri-draft-line",
    title: "Not Checking Passport Expiration Rules",
    description: "Many countries require 6 months of passport validity beyond your travel dates. Always verify the entry requirements for your specific destination.",
  },
  {
    icon: "ri-shield-star-line",
    title: "Military Families Missing Special Rules",
    description: "Soldiers and families at Fort Wainwright or Eielson AFB may have different processing pathways. FPC works with military families and understands active duty documentation requirements.",
  },
];

export default function MistakesSection() {
  return (
    <section id="mistakes" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            6 Passport Mistakes Fairbanks Applicants Make
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Avoid these common pitfalls that delay Fairbanks passport applications — several unique to Interior Alaska&apos;s remote geography and extreme weather.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 mb-4">
                <i className={`${m.icon} text-red-500 text-lg`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{m.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{m.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}